import { Outlet } from 'react-router-dom';

const DeviceIndexPage: React.FC = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default DeviceIndexPage;
